var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view'),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js?{"ident":"vue-loader-options"}!./node_modules/vue-loader/lib?{"ident":"vue-loader-options"}!./src/App.vue?vue&type=template&id=3ead68a0
// module id = 186
// module chunks = 0